window.jQuery = window.$ = require("jquery");
require("./vendor/jquery-migrate-1.4.1.min.js");

require("@fancyapps/fancybox/dist/jquery.fancybox.min.css");
require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");

require("jquery-mousewheel");
require("malihu-custom-scrollbar-plugin");

window.$(function () {
    require("./mobile-menu").default.init();
    require("./main-menu").default.init();
    require("./h100");
    require("./catalogFilter");
    require("./popup-form");
    require("./navSliderTabs.js");
    require("./sliderProducts.js");
    require("./btn-more.js");
    require("./scrollNav.js");
    require("./stickyfill.js");
});
